const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const mediaHost = apiBaseUrl ? new URL(apiBaseUrl).origin + "/" : "";

export const mediaUrl = (u) =>
  u ? `${mediaHost}${String(u).replace(/^\/+/, "")}` : "";
